import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AuthContext } from "@/App";
import { PackageCheck, ShieldCheck, TrendingUp } from "lucide-react";

export default function Login() {
  const { user, loading } = useContext(AuthContext);
  if (!loading && user) return <Navigate to="/" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      {/* Left: hero */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-20" />
        <div className="relative z-10">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded bg-emerald-500 grid place-items-center">
              <PackageCheck className="h-5 w-5 text-slate-900" />
            </div>
            <span className="font-display font-bold text-xl tracking-tight">GudangKu</span>
          </div>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="font-display text-4xl xl:text-5xl font-bold leading-[1.05]">
            Kendali Penuh<br />Gudang & Armada Sales
          </h1>
          <p className="text-slate-300 text-sm max-w-md leading-relaxed">
            Pantau stok gudang, stok berjalan armada, penjualan, retur, dan selisih fisik dalam satu neraca harian.
          </p>
          <div className="grid gap-3 text-sm">
            <div className="flex items-center gap-3">
              <TrendingUp className="h-4 w-4 text-emerald-400" />
              <span className="text-slate-200">Neraca Barang harian otomatis</span>
            </div>
            <div className="flex items-center gap-3">
              <ShieldCheck className="h-4 w-4 text-emerald-400" />
              <span className="text-slate-200">Deteksi selisih & stock checker anti hilang</span>
            </div>
          </div>
        </div>
        <div className="relative z-10 text-xs font-mono uppercase tracking-wider text-slate-500">
          v1.0 · Bahasa Indonesia
        </div>
      </div>

      {/* Right: login */}
      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex items-center gap-2">
            <div className="h-9 w-9 rounded bg-slate-900 grid place-items-center">
              <PackageCheck className="h-5 w-5 text-emerald-400" />
            </div>
            <span className="font-display font-bold text-xl">GudangKu</span>
          </div>
          <div className="mb-2 text-xs font-mono uppercase tracking-wider text-slate-500">Masuk / Login</div>
          <h2 className="font-display text-3xl font-bold text-slate-900 mb-2">Selamat datang kembali</h2>
          <p className="text-slate-500 text-sm mb-8">Gunakan akun Google Anda untuk mengakses dashboard gudang & armada.</p>
          <Button
            data-testid="login-google-btn"
            onClick={handleLogin}
            className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-medium"
          >
            <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Masuk dengan Google
          </Button>
          <p className="mt-6 text-xs text-slate-500 leading-relaxed">
            Login pertama kali akan otomatis membuat akun. Akun <span className="font-mono">hadziq.rifai@gmail.com</span> akan diberi role Owner.
          </p>
        </div>
      </div>
    </div>
  );
}
